const time = {
    msSinceEpoch: () =>  Math.floor( Date.now() )
}

export default time